<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>Add Result</h3>
        </div>
    </div>
</header>
<main>
    <div class="add-result">
        <form>
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Enter Student's Fullname" />
            </div>
            <div class="form-group">
                <input type="text" class="form-control" placeholder="City/Village" />
            </div>
            <div class="form-group">
                <select class="form-control">
                    <option selected="selected" disabled>Select Standard</option>
                    <option value="Standard 1">Standard 1</option>
                    <option value="Standard 2">Standard 2</option>
                    <option value="Standard 3">Standard 3</option>
                    <option value="Standard 4">Standard 4</option>
                    <option value="Standard 5">Standard 5</option>
                    <option value="Standard 6">Standard 6</option>
                    <option value="Standard 7">Standard 7</option>
                    <option value="Standard 8">Standard 8</option>
                    <option value="Standard 9">Standard 9</option>
                    <option value="Standard 10">Standard 10</option>
                    <option value="Standard 11">Standard 11</option>
                    <option value="Standard 12">Standard 12</option>
                </select>
            </div>
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Add Percentage" />
            </div>
            <div class="form-group">
                <input type="file" class="form-control" placeholder="Upload Result" />
            </div>
            <button type="submit" class="btn-common">Add Result</button>
        </form>
    </div>
</main>